import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CommonService } from '../../services/index';
import * as _ from 'lodash';
import swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../store';

@Component({
    selector: 'dsr-report-conversion',
    templateUrl: './dsrReportConversion.component.html'
})

export class DsrReportConversionComponent implements OnInit, OnDestroy {
    @Input() params: any;
    @Input() active = false;

    currentView: string = 'folders'; // folders | files
    fileSubView: string = 'year';    // year | month | fileList (virtual navigation inside files view)

    // All files fetched from API (raw)
    allFilesRaw: any[] = [];

    // Virtual grouping
    yearList: any[] = [];
    monthList: any[] = [];
    selectedVirtualYear: string = '';
    selectedVirtualMonth: string = '';

    filteredFileList: any[] = [];
    breadcrumbs: any[] = [];
    isLoadMask: Promise<any>;
    searchText: string = '';
    folderStats: any = null;
    branchReportFiles: any[] = [];
    branchSubfolders: any[] = [];
    folderPath: string[] = [];

    branchFolders: any[] = [];
    selectedBranchFolder: string = '';
    currentFolderFileCount: number = 0;

    subscribeAuth: any;
    usertype: string = '';
    branch_short_name: string = '';

    exportFromDate: string = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0];
    exportToDate: string = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];
    isExporting: boolean = false;
    isRunningAll: boolean = false;
    showRunAllModal: boolean = false;
    runAllRunId: string = '';
    runAllLogs: any[] = [];
    runAllDone: number = 0;
    runAllTotal: number = 0;
    runAllFinished: boolean = false;
    runAllPollInterval: any = null;

    reportOptions: any[] = [
        { key: 'unsold_update',               label: 'Unsold Update' },
        { key: 'promo_daily',                 label: 'Promo Daily' },
        { key: 'overall_audiologist',         label: 'Overall Audiologist' },
        { key: 'whatsapp_sta',                label: 'Whatsapp STA' },
        { key: 'pro_report',                  label: 'Pro Report' },
        { key: 'overall_soa',                 label: 'Overall SOA' },
        { key: 'overall_bic',                 label: 'Overall BIC' },
        { key: 'overall_branch',              label: 'Overall Branch' },
        { key: 'unsold_retrial_report',       label: 'Unsold Retrial Report' },
        { key: 'overall_audiologist_with_sta', label: 'Overall Audiologist With STA' },
    ];
    showSingleRunDropdown: boolean = false;
    isRunningSingle: boolean = false;
    showSingleModal: boolean = false;
    singleRunKey: string = '';
    singleRunLabel: string = '';
    singleRunId: string = '';
    singleRunLog: any = null;
    singleRunFinished: boolean = false;
    singlePollInterval: any = null;

    showMailModal: boolean = false;
    mailFile: any = null;
    mailRecipients: any[] = [];
    selectedMailRecipients: any[] = [];
    mailLoadingRecipients: boolean = false;
    mailSearch: string = '';
    mailSubject: string = '';
    mailBody: string = '';
    isSendingMail: boolean = false;

    monthNames = [
        { id: '01', name: 'January' },
        { id: '02', name: 'February' },
        { id: '03', name: 'March' },
        { id: '04', name: 'April' },
        { id: '05', name: 'May' },
        { id: '06', name: 'June' },
        { id: '07', name: 'July' },
        { id: '08', name: 'August' },
        { id: '09', name: 'September' },
        { id: '10', name: 'October' },
        { id: '11', name: 'November' },
        { id: '12', name: 'December' }
    ];

    constructor(private commonService: CommonService, private store: Store<fromCommonStore.State>) { }

    ngOnInit(): void {
        this.loadBranchFolders();
        this.updateBreadcrumbs();

        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth && auth.islogin) {
                this.usertype = auth.usertype;
                this.branch_short_name = auth.branch_short_name;
            }
        });
    }

    ngOnDestroy() {
        if (this.subscribeAuth) {
            this.subscribeAuth.unsubscribe();
        }
    }

    loadBranchFolders() {
        let that = this;
        this.isLoadMask = this.commonService
            .getBranchFolders()
            .then(function (res: any) {
                if (res.success) {
                    that.branchFolders = res.folders;
                } else {
                    console.error('Failed to load branch folders:', res.message);
                }
            })
            .catch(function (error) {
                console.error('Error loading branch folders:', error);
            });
    }

    onBranchFolderChange() {
        if (this.selectedBranchFolder) {
            this.currentView = 'files';
            this.fileSubView = 'year';
            this.selectedVirtualYear = '';
            this.selectedVirtualMonth = '';
            this.loadBranchReportFiles();
            this.loadFolderStats();
            this.updateBreadcrumbs();
        } else {
            this.resetToHome();
        }
    }

    loadBranchReportFiles() {
        let that = this;
        const folderName = this.folderPath.join('/');
        const params: any = { folderName: folderName };

        this.isLoadMask = this.commonService
            .getBranchFolderFiles(params)
            .then(function (res: any) {
                if (res.success) {
                    that.currentFolderFileCount = res.file_count || 0;

                    that.branchSubfolders = (res.folders || []).map(folder => ({
                        name: folder.display_name || folder.name,
                        folderName: folder.name,
                        type: 'folder',
                        files_count: folder.file_count || 0
                    }));

                    if (that.usertype && that.usertype !== 'Admin' && that.usertype !== 'Super_Admin') {
                        that.branchSubfolders = that.branchSubfolders.filter(folder =>
                            folder.folderName.toLowerCase() === that.branch_short_name.toLowerCase()
                        );
                    }

                    that.allFilesRaw = (res.files || []).map(file => {
                        const d = file.modified ? new Date(file.modified) : null;
                        const year = d && !isNaN(d.getTime()) ? d.getFullYear().toString() : '';
                        const month = d && !isNaN(d.getTime()) ? ('0' + (d.getMonth() + 1)).slice(-2) : '';
                        return {
                            name: file.name,
                            path: file.path,
                            size: that.formatBytes(file.size),
                            sizeRaw: file.size,
                            date: that.formatDate(file.modified),
                            modified: file.modified,
                            extension: file.extension,
                            type: 'file',
                            year: year,
                            month: month
                        };
                    });

                    that.buildYearList();
                    that.applySearchFilter();
                } else {
                    that.branchSubfolders = [];
                    that.allFilesRaw = [];
                    that.filteredFileList = [];
                    swal('Error', res.message, 'error');
                }
            })
            .catch(function (error) {
                console.error('Error loading files:', error);
                swal('Error', 'Failed to load files', 'error');
            });
    }

    buildYearList() {
        const years = {};
        this.allFilesRaw.forEach(f => {
            if (f.year) {
                years[f.year] = (years[f.year] || 0) + 1;
            }
        });
        this.yearList = Object.keys(years).sort((a, b) => +b - +a).map(y => ({
            name: y,
            type: 'virtual-year',
            files_count: years[y]
        }));
    }

    buildMonthList() {
        const months = {};
        this.allFilesRaw
            .filter(f => f.year === this.selectedVirtualYear)
            .forEach(f => {
                if (f.month) {
                    months[f.month] = (months[f.month] || 0) + 1;
                }
            });
        this.monthList = Object.keys(months).sort().map(m => {
            const monthObj = this.monthNames.find(mn => mn.id === m);
            return {
                name: monthObj ? monthObj.name : m,
                monthId: m,
                type: 'virtual-month',
                files_count: months[m]
            };
        });
    }

    loadFolderStats() {
        let that = this;
        const params = { folderName: this.selectedBranchFolder };
        this.commonService
            .getBranchFolderStats(params)
            .then(function (res: any) {
                if (res.success) {
                    that.folderStats = res;
                }
            })
            .catch(function (error) {
                console.error('Error loading folder stats:', error);
            });
    }

    onSearchChange() {
        this.applySearchFilter();
    }

    applyFilters() {
        if (this.selectedBranchFolder) {
            this.loadBranchReportFiles();
        }
    }

    applySearchFilter() {
        let files = this.allFilesRaw;

        if (this.fileSubView === 'fileList') {
            files = files.filter(f =>
                f.year === this.selectedVirtualYear && f.month === this.selectedVirtualMonth
            );
        }

        if (this.searchText) {
            const s = this.searchText.toLowerCase();
            files = files.filter(f => f.name.toLowerCase().includes(s));
        }

        this.filteredFileList = files;
    }

    formatBytes(bytes: number): string {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    onItemClick(item: any) {
        if (item.type === 'folder' && this.currentView === 'folders') {
            this.selectedBranchFolder = item.folderName;
            this.folderPath = [item.folderName];
            this.onBranchFolderChange();
            this.loadFolderStats();
        } else if (item.type === 'folder' && this.currentView === 'files') {
            // Real subfolder
            this.folderPath.push(item.folderName);
            this.currentView = 'files';
            this.fileSubView = 'year';
            this.selectedVirtualYear = '';
            this.selectedVirtualMonth = '';
            this.searchText = '';
            this.loadBranchReportFiles();
            this.updateBreadcrumbs();
        } else if (item.type === 'virtual-year') {
            this.selectedVirtualYear = item.name;
            this.fileSubView = 'month';
            this.buildMonthList();
            this.updateBreadcrumbs();
        } else if (item.type === 'virtual-month') {
            this.selectedVirtualMonth = item.monthId;
            this.fileSubView = 'fileList';
            this.applySearchFilter();
            this.updateBreadcrumbs();
        } else if (item.type === 'file') {
            this.downloadFile(item);
        }
    }

    downloadFile(file: any) {
        let that = this;

        if (this.folderPath.length > 0) {
            const params = {
                folderName: this.folderPath.join('/'),
                fileName: file.name
            };

            this.isLoadMask = this.commonService
                .downloadBranchFile(params)
                .then(function (res: any) {
                    if (res['_body']) {
                        const headers = res['headers']['_headers'];
                        const ctype = headers.get('content-type')[0];
                        const cdispos = headers.get('content-disposition')[0];

                        let filename = file.name;
                        if (cdispos) {
                            const filenameMatch = cdispos.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                            if (filenameMatch && filenameMatch[1]) {
                                filename = filenameMatch[1].replace(/['"]/g, '');
                            }
                        }

                        const blob = new Blob([res['_body']], { type: ctype });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        link.click();
                    } else {
                        swal('Error', 'File not found', 'error');
                    }
                })
                .catch(function (error) {
                    swal('Error', 'Failed to download file', 'error');
                });
        }
    }

    navigateTo(index: any) {
        if (index === -1) {
            this.resetToHome();
        } else if (index === 'root-folder') {
            this.folderPath = [this.folderPath[0]];
            this.fileSubView = 'year';
            this.selectedVirtualYear = '';
            this.selectedVirtualMonth = '';
            this.searchText = '';
            this.loadBranchReportFiles();
            this.updateBreadcrumbs();
        } else if (index === 'year') {
            // Back to month list
            this.fileSubView = 'month';
            this.selectedVirtualMonth = '';
            this.buildMonthList();
            this.updateBreadcrumbs();
        } else if (typeof index === 'number' && index >= 0 && this.folderPath.length > 0) {
            // Real subfolder breadcrumb
            this.folderPath = this.folderPath.slice(0, index + 1);
            this.currentView = 'files';
            this.fileSubView = 'year';
            this.selectedVirtualYear = '';
            this.selectedVirtualMonth = '';
            this.searchText = '';
            this.loadBranchReportFiles();
            this.selectedBranchFolder = this.folderPath[0];
            this.loadFolderStats();
            this.updateBreadcrumbs();
        }
    }

    resetToHome() {
        this.currentView = 'folders';
        this.fileSubView = 'year';
        this.selectedBranchFolder = '';
        this.folderPath = [];
        this.selectedVirtualYear = '';
        this.selectedVirtualMonth = '';
        this.allFilesRaw = [];
        this.branchReportFiles = [];
        this.branchSubfolders = [];
        this.filteredFileList = [];
        this.yearList = [];
        this.monthList = [];
        this.folderStats = null;
        this.currentFolderFileCount = 0;
        this.searchText = '';
        this.updateBreadcrumbs();
    }

    updateBreadcrumbs() {
        this.breadcrumbs = [{ name: 'Home', index: -1 }];

        if (this.folderPath.length > 0) {
            this.folderPath.forEach((folder, idx) => {
                if (idx === 0) {
                    const folderObj = this.branchFolders.find(f => f.name === folder);
                    const folderName = folderObj ? folderObj.display_name : folder;
                    this.breadcrumbs.push({ name: folderName, index: idx === 0 ? 'root-folder' : idx });
                } else {
                    this.breadcrumbs.push({ name: folder, index: idx });
                }
            });
        }

        if (this.selectedVirtualYear) {
            this.breadcrumbs.push({ name: this.selectedVirtualYear, index: 'year' });
        }

        if (this.selectedVirtualMonth) {
            const monthObj = this.monthNames.find(m => m.id === this.selectedVirtualMonth);
            const monthName = monthObj ? monthObj.name : this.selectedVirtualMonth;
            this.breadcrumbs.push({ name: monthName, index: 'month' });
        }
    }

    getCurrentList() {
        if (this.currentView === 'folders') {
            return this.branchFolders.map(folder => ({
                name: folder.display_name,
                folderName: folder.name,
                type: 'folder'
            }));
        }

        if (this.currentView === 'files') {
            if (this.fileSubView === 'year') {
                return [...this.branchSubfolders, ...this.yearList];
            } else if (this.fileSubView === 'month') {
                return this.monthList;
            } else {
                return this.filteredFileList;
            }
        }

        return [];
    }

    getIcon(item: any) {
        if (item.type === 'folder' || item.type === 'virtual-year' || item.type === 'virtual-month') {
            return 'fa-folder';
        }
        return 'fa-file-excel-o';
    }

    getFolderDisplayName(folderName: string): string {
        if (!folderName) return '';
        const folderObj = this.branchFolders.find(f => f.name === folderName);
        return folderObj ? folderObj.display_name : folderName;
    }

    onCronExport(): void {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        this.exportFromDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
        this.exportToDate = yesterday.toISOString().split('T')[0];
        this.isExporting = true;
        const params = {
            from_date: this.exportFromDate,
            to_date: this.exportToDate,
            start: 0,
            limit: 999999,
            orderColumn: 'date',
            orderDir: 'DESC'
        };
        this.commonService.cronExportDsr(params).then((res: any) => {
            this.isExporting = false;
            if (res && res.success) {
                swal('SUCCESS', res.message + (res.fileName ? '\nFile: ' + res.fileName : ''), 'success');
            } else {
                swal('ERROR', res && res.message ? res.message : 'Export failed', 'error');
            }
        }).catch(() => {
            this.isExporting = false;
            swal('ERROR', 'Export failed', 'error');
        });
    }

    onRunAll(): void {
        this.isRunningAll = true;
        this.commonService.runAllReports().then((res: any) => {
            this.isRunningAll = false;
            if (res && res.success && res.run_id) {
                this.runAllRunId = res.run_id;
                this.runAllLogs = [];
                this.runAllFinished = false;
                this.showRunAllModal = true;
                this.startRunAllPolling();
            } else {
                swal('ERROR', res && res.message ? res.message : 'Failed to start reports', 'error');
            }
        }).catch(() => {
            this.isRunningAll = false;
            swal('ERROR', 'Failed to start Run All Reports', 'error');
        });
    }

    startRunAllPolling(): void {
        const self = this;
        this.runAllPollInterval = setInterval(function() {
            self.commonService.getRunAllStatus(self.runAllRunId).then(function(res: any) {
                if (res && res.success) {
                    self.runAllLogs = res.logs || [];
                    self.runAllDone = res.done || 0;
                    self.runAllTotal = res.total || 0;
                    if (res.finished) {
                        self.runAllFinished = true;
                        clearInterval(self.runAllPollInterval);
                        self.loadBranchFolders();
                    }
                }
            });
        }, 3000);
    }

    closeRunAllModal(): void {
        if (this.runAllPollInterval) {
            clearInterval(this.runAllPollInterval);
            this.runAllPollInterval = null;
        }
        this.showRunAllModal = false;
        this.runAllRunId = '';
        this.runAllLogs = [];
        this.runAllDone = 0;
        this.runAllTotal = 0;
        this.runAllFinished = false;
    }

    onSendMail(file: any): void {
        this.mailFile = file;
        this.mailSubject = 'Report: ' + file.name;
        this.mailBody = '';
        this.mailRecipients = [];
        this.selectedMailRecipients = [];
        this.showMailModal = true;

        this.mailLoadingRecipients = true;
        this.commonService.getEmployeeEmailList({ start: 0, limit: 9999 }).then((res: any) => {
            this.mailLoadingRecipients = false;
            if (res && res.data) {
                this.mailRecipients = res.data
                    .filter((r: any) => r.status === 'Active')
                    .map((r: any) => ({ mail_id: r.email, name: r.employee_name, selected: false }));
            }
        }).catch(() => { this.mailLoadingRecipients = false; });
    }

    getReportNameFromFile(fileName: string): string {
        const base = fileName.replace(/\.[^/.]+$/, '');
        const stripped = base
            .replace(/_\d{1,2}[A-Za-z]{3}\d{4}$/, '')
            .replace(/_\d{4}-\d{2}-\d{2}$/, '')
            .replace(/_\d{6,8}$/, '')
            .replace(/_+$/, '');
        return stripped;
    }

    getSelectedMailCount(): number {
        return this.mailRecipients.filter((r: any) => r.selected).length;
    }

    filteredMailRecipients(): any[] {
        if (!this.mailSearch) { return this.mailRecipients; }
        const s = this.mailSearch.toLowerCase();
        return this.mailRecipients.filter((r: any) => r.name.toLowerCase().includes(s) || r.mail_id.toLowerCase().includes(s));
    }

    selectAllMail(): void {
        this.filteredMailRecipients().forEach((r: any) => { r.selected = true; });
    }

    clearAllMail(): void {
        this.filteredMailRecipients().forEach((r: any) => { r.selected = false; });
    }

    closeMailModal(): void {
        this.showMailModal = false;
        this.mailFile = null;
        this.mailRecipients = [];
        this.selectedMailRecipients = [];
        this.mailSearch = '';
        this.mailSubject = '';
        this.mailBody = '';
    }

    confirmSendMail(): void {
        if (!this.mailFile || this.getSelectedMailCount() === 0) { return; }
        this.isSendingMail = true;
        const payload = {
            folderName: this.folderPath.join('/'),
            fileName: this.mailFile.name,
            subject: this.mailSubject,
            body: this.mailBody,
            recipients: this.mailRecipients.filter((r: any) => r.selected).map((r: any) => r.mail_id).join(',')
        };
        this.commonService.sendReportMail(payload).then((res: any) => {
            this.isSendingMail = false;
            if (res && res.success) {
                this.closeMailModal();
                swal('SUCCESS', res.message, 'success');
            } else {
                swal('ERROR', res && res.message ? res.message : 'Failed to send mail', 'error');
            }
        }).catch(() => {
            this.isSendingMail = false;
            swal('ERROR', 'Failed to send mail', 'error');
        });
    }

    getTotalSubfolderFiles(): number {
        if (!this.branchSubfolders || this.branchSubfolders.length === 0) return 0;
        return this.branchSubfolders.reduce((total, folder) => total + (folder.files_count || 0), 0);
    }

    onRunSingle(option: any): void {
        this.showSingleRunDropdown = false;
        this.isRunningSingle = true;
        this.commonService.runSingleReport(option.key).then((res: any) => {
            this.isRunningSingle = false;
            if (res && res.success && res.run_id) {
                this.singleRunKey = option.key;
                this.singleRunLabel = option.label;
                this.singleRunId = res.run_id;
                this.singleRunLog = null;
                this.singleRunFinished = false;
                this.showSingleModal = true;
                this.startSinglePolling();
            } else {
                swal('ERROR', res && res.message ? res.message : 'Failed to start report', 'error');
            }
        }).catch(() => {
            this.isRunningSingle = false;
            swal('ERROR', 'Failed to start report', 'error');
        });
    }

    startSinglePolling(): void {
        const self = this;
        this.singlePollInterval = setInterval(function() {
            self.commonService.getSingleRunStatus(self.singleRunId).then(function(res: any) {
                if (res && res.success && res.logs && res.logs.length > 0) {
                    self.singleRunLog = res.logs[0];
                    if (self.singleRunLog.status === 'success' || self.singleRunLog.status === 'failed') {
                        self.singleRunFinished = true;
                        clearInterval(self.singlePollInterval);
                        self.loadBranchFolders();
                    }
                }
            });
        }, 3000);
    }

    closeSingleModal(): void {
        if (this.singlePollInterval) {
            clearInterval(this.singlePollInterval);
            this.singlePollInterval = null;
        }
        this.showSingleModal = false;
        this.singleRunKey = '';
        this.singleRunLabel = '';
        this.singleRunId = '';
        this.singleRunLog = null;
        this.singleRunFinished = false;
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/dsrReportConversion.component.ts